import AbstractScene from './AbstractScene.js';

import {Colors} from "../consts/Colors.js"
import {tags} from "../consts/Tags.js"

import RoundedButton from '../prefabs/RoundedButton.js';

export default class Menu extends AbstractScene {
    constructor() {
        super({
            key: "Menu"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        
        this._preload();

        this.questionGroup = this.add.group()
    }

    create(){
        // Background
        var back = this.add.sprite(this.width, 0, 'intro').setOrigin(1, 0)
        back.setScale(0.45)

        var rect = this.add.sprite(0,0, 'rectIntro').setOrigin(0)
        
        // Ajout line
        var line = this.add.sprite(0, this.height, 'backLine').setOrigin(0, 1)

        // Ajout logo
        var logoABC = this.add.sprite(450, 180, "mqde")

        // Ajout titre
        var Y = 390
        var titreFond = this.add.rexTagText(110, Y-1, "Tribunaux de commerce :", {
            fontSize: "72px",
            fontFamily: "MassiliaBold",
            align: 'left',
            color: Colors.Text.White,
            stroke: Colors.Text.Black,
            strokeThickness: 2,
            backgroundColor: 'transparent',
            wrap: {
                mode: 'word',
                width: 700
            },
            tags: tags
        })
        titreFond.setOrigin(0, 0.5)

        // Ajout sous-titre
        var Ytxt = 465
        var text = "Mesures de prévention et de traitement des difficultés des entreprises"
                    
        var textElmt = this.add.rexTagText(titreFond.x, Ytxt, text, {
            fontSize: "50px",
            fontFamily: "MassiliaRegular",
            align: 'left',
            color: Colors.Text.White,
            backgroundColor: 'transparent',
            tags: tags,
            wrap: {
                mode: 'word',
                width: 700
            },
        })
        textElmt.setOrigin(0)

        var Ytxt = 640
        var text = "Après avoir visionné la vidéo,\n"   
                    +"découvrez <class=\"bold\">le jeu pédagogique</class> sur\n"  
                    +"les tribunaux de commerce."
                    +"\n\nRestez bien jusqu'à la fin pour tester vos"
                    +"\nconnaissances !"
                    
        var textElmt = this.add.rexTagText(titreFond.x, Ytxt, text, {
            fontSize: "35px",
            fontFamily: "MassiliaRegular",
            align: 'left',
            color: Colors.Text.White,
            backgroundColor: 'transparent',
            tags: tags
        })
        textElmt.setOrigin(0)

        // Ajout bouton
        var button = new RoundedButton(this, this.width/2, 965, 500, 100, "Démarrer la vidéo", Colors.Text.Purple, Colors.Elmt.Purple)
        button.setClickFunction(()=>{this.nextScene()})
    }
}